import getReducer from '../getReducer';
import assign from 'object-assign';

import {LEAVE_LIST_REQUEST, LEAVE_LIST_SUCCESS, LEAVE_LIST_FAILURE} from '../../action/leave/list'
import {USER_GET_ALL_REQUEST, USER_GET_ALL_SUCCESS, USER_GET_ALL_FAILURE} from '../../action/user/getall'
import { LEAVE_RECORD_REQUEST, LEAVE_RECORD_SUCCESS, LEAVE_RECORD_FAILURE } from '../../action/leave/leaveRecord';

import { ADJUST_LIST_REQUEST, ADJUST_LIST_SUCCESS, ADJUST_LIST_FAILURE } from '../../action/leave/adjustList';
import { UPDATE_ADJUST_REQUEST, UPDATE_ADJUST_SUCCESS, UPDATE_ADJUST_FAILURE } from '../../action/leave/updateAdjust';

function leave(state = {
	showLoading: false,
	allUsers: [],
	leaveList: {
		data: [],
		page: 1,
		total: 0,
		pageSize: 10
	},
	adjustList: {
		data: [],
		page: 1,
		total: 0,
		pageSize: 10
	}

}, action) {
	switch (action.type) {
		// 假期管理
		case LEAVE_LIST_REQUEST:
			return assign({}, state, {})
		case LEAVE_LIST_SUCCESS:
			return assign({}, state, {
				leaveList: assign({}, state.leaveList, action.response.result)}
			)
		case LEAVE_LIST_FAILURE:
			return assign({}, state, {})
		// 请假记录
		case LEAVE_RECORD_REQUEST:
			return assign({}, state, {})
		case LEAVE_RECORD_SUCCESS:
			var result = action.response.result;
			return assign({}, state, {
				leaveList: assign({}, state.leaveList, result)}
			)
		case LEAVE_RECORD_FAILURE:
			return assign({}, state, {})

		 // 获取所有员工
    case USER_GET_ALL_REQUEST:
     return assign({}, state, {showLoading: true})
    case USER_GET_ALL_SUCCESS:
     return assign({}, state, {
       allUsers: action.response.result.users,
       showLoading: false
     })
    case USER_GET_ALL_FAILURE:
     return assign({}, state, {
       showLoading: false
     })
		
		// 调休列表
		case ADJUST_LIST_REQUEST:
			return assign({}, state, {})
		case ADJUST_LIST_SUCCESS:
			return assign({}, state, {
				adjustList: assign({}, state.leaveList, action.response.result)}
			)
		case ADJUST_LIST_FAILURE:
			return assign({}, state, {})
		
		// 更新调休
		case UPDATE_ADJUST_REQUEST:
			return assign({}, state, {showLoading: true})
		case UPDATE_ADJUST_SUCCESS:
			return assign({}, state, {showLoading: false}
			)
		case UPDATE_ADJUST_FAILURE:
			return assign({}, state, {showLoading: false})

		default:
			return state
	}
}

export default getReducer(leave);


// WEBPACK FOOTER //
// ./src/reducer/leave/list.js